const translations = {
    LOGIN_NTLM_BUTTON: {
        description: 'This is a button to log into our system via NTLM. this text is the text for the this button',
        primaryValue: 'Log in with your Nike Account',
        stringKey: 'LOGIN_NTLM_BUTTON',
    },
    LOGIN_ATHLETE_BUTTON: {
        description: 'Text for Login button for Athlete users that need to use that form of authentication',
        primaryValue: 'Athlete username & password',
        stringKey: 'LOGIN_ATHLETE_BUTTON',
    },

};

export default translations;